var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import Transition from 'react-transition-group/Transition';
import { compose } from 'recompose';
import { getFormValues, reset } from 'redux-form';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { reDraw } from '@/helpers/common';
import { propFunc, propShape, propHistory } from '@/helpers/custom-prop-types';
import { openFileNewTab, uploadFilePromiseAndGetTemporaryId, } from '@/helpers/files';
import { apiUpdateClientConsultation } from '../../../../actions/ClientMyPageActions';
import { showAlert as showAlertAction } from '../../../../actions/NotificationActions';
import Layout from '../../../Layout';
import { FaqSearch } from '../MyPageCommon/Faq/FaqSearch';
import Navigation from '../MyPageCommon/Navigation/Navigation';
import ConsultationConfirmForm from './ConfirmForm/ConsultationConfirmForm';
class Confirm extends Component {
    constructor(props) {
        super(props);
        this.onSubmit = (formValues) => __awaiter(this, void 0, void 0, function* () {
            const { sendConsultations, showAlert, uploadFile } = this.props;
            const { showModal } = this.state;
            if (showModal) {
                return;
            }
            try {
                const submitValue = {
                    aboutMeetingTool: formValues.aboutMeetingTool,
                    additionalInformation: formValues.additionalInformation,
                    budget: formValues.budgetType === '1' ? formValues.budget : null,
                    budgetType: formValues.budgetType,
                    considerationEndAt: formValues.considerationType === '1'
                        ? null
                        : `${formValues.considerationEndYear}-${formValues.considerationEndMonth}-01`,
                    considerationType: formValues.considerationType,
                    contactable_time_1: formValues.contactableTime1,
                    contactable_time_2: formValues.contactableTime2,
                    contactable_time_3: formValues.contactableTime3,
                    files: [],
                    recruitmentType: formValues.recruitmentType,
                    whatRequest: formValues.whatRequest,
                };
                for (let i = 0; i < (formValues.files || []).length; i += 1) {
                    const { file } = formValues.files[i];
                    // eslint-disable-next-line no-await-in-loop
                    const uploadFileId = yield uploadFile(file);
                    submitValue.files.push(uploadFileId);
                }
                yield sendConsultations(submitValue);
                this.safeSetState({ showModal: true });
            }
            catch (e) {
                showAlert('システムエラーが発生しました。しばらく時間を置いてからやり直すか、管理者にお問い合わせください。');
                throw e;
            }
        });
        this.onClickFile = (e) => {
            const { value } = e.currentTarget;
            const { formValues: { files }, } = this.props;
            const { file } = files.find(({ id }) => id === value) || {};
            openFileNewTab(file);
        };
        this.onBack = () => {
            const { history } = this.props;
            history.push('/mypage/consultation');
        };
        this.onClickCloseModal = () => {
            const { history } = this.props;
            history.push('/mypage');
        };
        this.safeSetState = (state) => {
            if (!this.unmount) {
                this.setState(state);
            }
        };
        const { formValues } = props;
        this.state = {
            showModal: false,
            valid: !!formValues,
        };
        this.unmount = false;
    }
    componentWillUnmount() {
        const { showModal } = this.state;
        const { resetForm } = this.props;
        this.unmount = true;
        if (showModal || window.location.pathname !== '/mypage/consultation') {
            resetForm();
        }
    }
    render() {
        const { clientRfpCount: { rfp_unread_count: rfpUnreadCount }, formValues, } = this.props;
        const { showModal, valid } = this.state;
        // 直接確認画面へ遷移してきた場合は入力画面へ飛ばす
        if (!valid) {
            return _jsx(CustomRedirect, { to: '/mypage/consultation' });
        }
        return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main client_mypage' }, { children: [_jsxs("div", Object.assign({ className: 'mypage_container' }, { children: [_jsx(Navigation, { activeTab: 'consultations', rfpUnreadCount: rfpUnreadCount }), _jsxs("div", Object.assign({ className: 'mypage_card' }, { children: [_jsx("div", Object.assign({ className: 'card_header' }, { children: _jsx("h3", Object.assign({ className: 'label' }, { children: "\u5185\u5BB9\u78BA\u8A8D" })) })), _jsx("div", Object.assign({ className: 'card_body' }, { children: _jsx(ConsultationConfirmForm, { formValues: formValues, onBack: this.onBack, onClickFile: this.onClickFile, onSubmit: this.onSubmit }) }))] }))] })), _jsx(FaqSearch, {}), _jsx(Transition, Object.assign({ in: showModal, mountOnEnter: true, onEnter: reDraw, onExit: reDraw, timeout: 300, unmountOnExit: true }, { children: (state) => (_jsxs("div", Object.assign({ className: 'consultation_complete_modal' }, { children: [_jsx("div", { className: `consultation_complete_modal_bg ${state}` }), _jsxs("div", Object.assign({ className: `consultation_complete_modal_box ${state}` }, { children: [_jsx("h4", Object.assign({ className: 'consultation_complete_modal_header' }, { children: "\u3054\u76F8\u8AC7\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059" })), _jsxs("div", Object.assign({ className: 'consultation_complete_modal_content wbr' }, { children: ["\u30D5\u30A9\u30FC\u30E0\u3092\u9001\u4FE1\u3044\u305F\u3060\u304D\u3001", _jsx("wbr", {}), "\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\u3002", _jsx("br", {}), "1\u55B6\u696D\u65E5\u4EE5\u5185\u306B\u3001", _jsx("wbr", {}), "\u62C5\u5F53\u8005\u3088\u308A\u3054\u9023\u7D61\u5DEE\u3057\u4E0A\u3052\u307E\u3059\u3002"] })), _jsx("button", Object.assign({ className: 'consultation_complete_modal_close', onClick: this.onClickCloseModal, type: 'button' }, { children: "\u9589\u3058\u308B" }))] }))] }))) }))] })));
    }
}
Confirm.propTypes = {
    clientRfpCount: propShape().isRequired,
    formValues: propShape(),
    history: propHistory(),
    resetForm: propFunc().isRequired,
    sendConsultations: propFunc().isRequired,
    showAlert: propFunc().isRequired,
    uploadFile: propFunc().isRequired,
};
Confirm.defaultProps = {
    formValues: null,
};
const formName = 'ConsultationForm';
const mapStateToProps = (state) => ({
    clientRfpCount: state.clientRfpCount,
    formValues: getFormValues(formName)(state),
});
const mapDispatchToProps = (dispatch) => ({
    resetForm: () => dispatch(reset(formName)),
    sendConsultations: (values) => new Promise((resolve, reject) => {
        dispatch(apiUpdateClientConsultation(values, {
            reject,
            resolve,
        }));
    }),
    showAlert: (message) => dispatch(showAlertAction(message)),
    uploadFile: (file) => uploadFilePromiseAndGetTemporaryId({ dispatch, file }),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(Confirm);
